var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import React, { useContext, useEffect, useState } from "react";
import { EProductIds, EProductNames, ESubProductIds, } from "@frameworks/shared-library/components/Orderbook/common/OrderbookConstants";
import SummaryFilters from "@frameworks/NCD/Components/SearchPanelWithPopupFiltersLabel/Components/SummaryFilters";
import SearchPanelWithPopupFiltersLabel from "@frameworks/NCD/Components/SearchPanelWithPopupFiltersLabel/SearchPanelWithPopupFiltersLabel";
import { Provider, useSelector } from "react-redux";
import store from "@redux/store";
import OrdersTable from "../Components/OrdersTables";
import MFOrderbookCalendarFilter from "@frameworks/salesjourney/components/Features/ActivityBook/RM_Orderbook/common/MFOrderbookCalendarFilter/MFOrderbookCalendarFilter";
import OrderBookActions from "@redux/feature/Markets/NCD/actions/OrderBookActions";
import { EOrderBookOrderBy } from "@frameworks/NCD/Enum/OTC";
import { ProductOrderContext } from "@frameworks/salesjourney/components/Features/ActivityBook/RM_Orderbook/ProductOrders/ProductOrdersContext";
import { checkIfOtcIsAccessible } from "@frameworks/salesjourney/utils/genericMethods";
import ErrorOrComingSoon from "@frameworks/shared-library/components/Orderbook/common/ErrorOrComingSoon";
var AllTab = function (props) {
    var productOrdersContext = useContext(ProductOrderContext);
    var _a = __read(useState(true), 2), isOtcAccessible = _a[0], setIsOtcAccessible = _a[1];
    useEffect(function () {
        checkIfOtcIsAccessible()
            .then(function (value) {
            setIsOtcAccessible(value);
        })
            .catch(function (e) {
            console.error(e);
            setIsOtcAccessible(true);
        });
    }, []);
    var orderBookRequestPayload = useSelector(function (state) { return state.markets.Otc.orderBookReducer; }).orderBookRequestPayload;
    var cOrderBookActions = new OrderBookActions();
    var subCategories = [{ subCategoryId: "256" }, { subCategoryId: "257" }];
    var handleUpdateDateFiltersData = function (data) {
        var e_1, _a;
        try {
            for (var subCategories_1 = __values(subCategories), subCategories_1_1 = subCategories_1.next(); !subCategories_1_1.done; subCategories_1_1 = subCategories_1.next()) {
                var subCat = subCategories_1_1.value;
                var filtersObject = {
                    from_date: String(data.fromDate),
                    to_date: String(data.toDate),
                };
                if ((subCat === null || subCat === void 0 ? void 0 : subCat.subCategoryId) === ESubProductIds.NCD) {
                    cOrderBookActions.setOrderBookNcdRequestPayload(__assign({ category_code: Number(subCat === null || subCat === void 0 ? void 0 : subCat.subCategoryId), page_index: 1, page_size: 10, orderby: EOrderBookOrderBy.TRXDATE, orderbydesc: true }, filtersObject));
                }
                else {
                    cOrderBookActions.setOrderBookRequestPayload(__assign({ category_code: Number(subCat === null || subCat === void 0 ? void 0 : subCat.subCategoryId), page_index: 1, page_size: 10, orderby: EOrderBookOrderBy.TRXDATE, orderbydesc: true }, filtersObject));
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (subCategories_1_1 && !subCategories_1_1.done && (_a = subCategories_1.return)) _a.call(subCategories_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    if (!isOtcAccessible) {
        return React.createElement(ErrorOrComingSoon, null);
    }
    return (React.createElement(Provider, { store: store },
        React.createElement(SearchPanelWithPopupFiltersLabel, { parentClassName: "mb-10 ncd-filter mt-1", searchBarParentClassName: "w-400", searchValue: "", clearSearching: function () { return console.log("Clear search clicked"); }, applySearchedFilters: function (text) {
                return console.log("Search text:", text);
            }, isShowPopup: false, setIsShowPopup: function (val) { return console.log("Set popup:", val); }, placeholder: "Search by instrument, category, etc.", handleClearFilters: function () { return console.log("Clear all filters clicked"); }, isDotShow: false, iconClassName: "edel-icon-curved-filter", filterComponentInsidePopup: React.createElement(SummaryFilters, { handleFilterChangeCallback: function (updatedFilters) {
                    return console.log("Updated Filters:", updatedFilters);
                }, handleApplyCallback: function () { return console.log("Apply filters clicked"); }, handleCancelCallback: function () { return console.log("Cancel clicked"); }, handleClearAllCallback: function () { return console.log("Clear all clicked"); }, isShowFilterPopup: true, filtersData: undefined, searchedClient: "", setSearchedClient: function (value) {
                    throw new Error("Function not implemented.");
                } }), rightSubComponent: React.createElement(React.Fragment, null,
                React.createElement(MFOrderbookCalendarFilter, { filtersData: {
                        fromDate: orderBookRequestPayload === null || orderBookRequestPayload === void 0 ? void 0 : orderBookRequestPayload.from_date,
                        toDate: orderBookRequestPayload === null || orderBookRequestPayload === void 0 ? void 0 : orderBookRequestPayload.to_date,
                    }, handleApplyCallback: function () { }, handleFilterChangeCallback: handleUpdateDateFiltersData })), sortFilterComponentInsidePopup: React.createElement(React.Fragment, null), filterLabels: [], removeFilterThroughLabels: function () { return console.log("Remove "); }, isFilterHeader: true }),
        React.createElement("div", { className: "d-flex flex-column gap-3 bg_white" },
            React.createElement(OrdersTable, { isShowViewAll: !productOrdersContext.detailedViewEnabled, parentId: EProductNames.FIXED_INCOME, subCategoryId: Number(ESubProductIds.Bonds), viewAllButtonCallback: function () {
                    productOrdersContext.viewAllClickCallback(EProductIds.FIXED_INCOME, ESubProductIds.Bonds);
                }, setToastDetails: productOrdersContext.setToastDetails, title: "Bonds", isSingle: false, isMultiple: true, showFiltersComponent: productOrdersContext.detailedViewEnabled, isShowFilterHeader: productOrdersContext.detailedViewEnabled }),
            React.createElement(OrdersTable, { isShowViewAll: !productOrdersContext.detailedViewEnabled, parentId: EProductNames.FIXED_INCOME, subCategoryId: Number(ESubProductIds.NCD), viewAllButtonCallback: function () {
                    productOrdersContext.viewAllClickCallback(EProductIds.FIXED_INCOME, ESubProductIds.NCD);
                }, setToastDetails: productOrdersContext.setToastDetails, title: "NCD\u2019s", isSingle: true, isMultiple: true, showFiltersComponent: productOrdersContext.detailedViewEnabled, isShowFilterHeader: productOrdersContext.detailedViewEnabled }))));
};
export default AllTab;
